import "core-js/modules/es.regexp.exec.js";
import { defineComponent as _defineComponent } from 'vue';
import { useUpdateTextMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'CommercialRegisterTextFieldInput',
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    userInput: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _getCurrentInstance = getCurrentInstance(),
      proxy = _getCurrentInstance.proxy; // use this to translate the scoped <i18n> translations
    var form = ref();
    var _useUpdateTextMutatio = useUpdateTextMutation(),
      updateText = _useUpdateTextMutatio.mutate;
    function valueChange(text) {
      if (form.value.validate()) {
        updateText({
          userInputId: props.userInput.id,
          text: text
        });
      }
    }
    var regex = /^(HR[AB])\s\d{4,6}(?:\s[A-Z])?$/;
    var rules = [function (v) {
      return v === '' || regex.test(v) || proxy.$t('validationFailed');
    }];
    var _toRefs = toRefs(props),
      isEditable = _toRefs.isEditable;
    return {
      __sfc: true,
      proxy: proxy,
      form: form,
      props: props,
      updateText: updateText,
      valueChange: valueChange,
      regex: regex,
      rules: rules,
      isEditable: isEditable
    };
  }
});